
<div class="date-picker" [formGroup]="form"    (click)="toggleDatePicker($event)" #datepicker>
  <input [maxlength]="24"  onkeypress="return event.keyCode === 8 || event.charCode >= 48 && event.charCode <= 57"  [readonly]="isReadOnly" [class.disabled]="disabled" [placeholder]="field.placeholder?field.placeholder:''" [formControlName]="formName" 
  [class]="datepicker_serv.getClassName(field.inputClassName)"
  [ngClass]="{'is-invalid':isInValid}">
<div class="main"   [formGroup]="form" #main>
  <div class="month" #MONTH>
    <div class="arrows prev-mth"  [class]="datepicker_serv.getClassName(field.arrowClassName)" (click)="prevMonth()"></div>
    <div class="mth" [class]="datepicker_serv.getClassName(field.monthClassName)">
      <button  type="button" (click)="monthSelected($event)">{{ months[month] }}</button>
      &nbsp;
      <button type="button" (click)="selectYear($event)">{{ year }}</button>
    </div>
    <div class="arrows next-mth" [class]="datepicker_serv.getClassName(field.arrowClassName)" (click)="nextMonth()"></div>
  </div>
  <div class="days" #DAYS >
    <div class="day-head" *ngFor="let d of weekdays">
      {{ d }}
    </div>
    <ng-container *ngFor="let week of days">
      <ng-container *ngFor="let day of week">
        <div class="day"  [ngClass]="{
          selected:(this.range.start!==null&&day.date.toLocaleDateString() ==
              range.start.toLocaleDateString())||
            (this.range.end!==null &&
            day.date.toLocaleDateString() == range.end.toLocaleDateString()),
            daybetween:(this.range.start!==null&&this.range.end!==null)&&
              (day.date >
                range.start &&
              day.date < range.end),


            today:
              day.date.toLocaleDateString() == today.toLocaleDateString(),
            muted: !day.isMonth
          }" (click)="selectedDate(day)" [class]="datepicker_serv.getClassName(field.dayClassName)" >
          {{ day.day }}
        </div>
      </ng-container>
    </ng-container>
  </div>
  <div class="showallmonth" #showallmonth>
    <app-month [field]='field' (toggle)="monthSelected($event)"></app-month>
  </div>
  <div class="showyear" #showyear>
    <app-year [field]='field' (toggleYear)="yearSelected($event)"></app-year>
  </div>
  <div>
    <button type="button" class="btn reset" (click)="Reset()">reset</button>
  </div>
</div>
</div>